var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeenTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65945 6.87176C3.84382 4.46552 6.00945 1.3249 8.87195 2.1374C6.52195 3.54677 9.41882 6.50926 10.8626 4.12489C11.7688 7.62801 7.4532 9.22175 5.65945 6.87176Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8348 5.53736C11.8692 11.4342 4.13166 11.5405 0.159785 5.54048C-0.0558404 5.21236 -0.0527154 4.77486 0.166035 4.45298C4.13791 -1.39702 11.8317 -1.56889 15.8379 4.44673C16.0535 4.77174 16.0535 5.21236 15.8348 5.53736ZM1.99103 4.99361C5.76603 0.68736 10.3129 0.63111 14.0067 4.99361C10.3129 9.29673 5.74728 9.24049 1.99103 4.99361Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeenTransparent);
export default __webpack_public_path__ + "static/media/SeenTransparent.844ff9f5b171150fc75443244a36dc23.svg";
export { ForwardRef as ReactComponent };